type TDiv = JSX.IntrinsicElements['div'];

export type Error = Pick<TDiv, 'children' | 'className'>;

export function Error({ children, className }: Error) {
  if (!children) {
    return null;
  }

  return (
    <div className={className}>
      <span className="text-12 font-normal text-red-600">{children}</span>
    </div>
  );
}
